var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "2500px",
    viewBox: "0 0 2500 2500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "markdown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "markdown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2327.8418,2020.91406 L179.638672,2020.91406 C82.3339844,2020.91406 0,1938.58984 0,1841.27539 L0,658.638672 C0,561.333984 82.3339844,479 179.638672,479 L2320.36133,479 C2417.66602,479 2500,561.333984 2500,658.638672 L2500,1841.27539 C2500,1938.58008 2425.14648,2020.91406 2327.8418,2020.91406 L2327.8418,2020.91406 Z M179.638672,598.755859 C149.697266,598.755859 119.755859,628.697266 119.755859,658.638672 L119.755859,1841.27539 C119.755859,1878.69727 149.697266,1901.1582 179.638672,1901.1582 L2320.36133,1901.1582 C2357.7832,1901.1582 2380.24414,1871.2168 2380.24414,1841.27539 L2380.24414,658.638672 C2380.24414,621.216797 2350.30273,598.755859 2320.36133,598.755859 L179.638672,598.755859 Z M359.277344,1661.63672 L359.277344,838.277344 L598.798828,838.277344 L838.320312,1137.69141 L1077.8418,838.277344 L1317.36328,838.277344 L1317.36328,1661.63672 L1077.8418,1661.63672 L1077.8418,1190.07422 L838.320312,1489.48828 L598.798828,1190.07422 L598.798828,1661.63672 L359.277344,1661.63672 L359.277344,1661.63672 Z M1863.76953,1661.63672 L1504.49219,1264.92773 L1744.01367,1264.92773 L1744.01367,838.277344 L1983.53516,838.277344 L1983.53516,1257.44727 L2223.05664,1257.44727 L1863.7793,1661.63672 L1863.76953,1661.63672 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdown);
export default __webpack_public_path__ + "static/media/markdown.3680b71be9faf1c5f749196b5acb5ee5.svg";
export { ForwardRef as ReactComponent };